import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { PERMISSIONS } from '@repo/shared/domain';
import { getAuthenticatedUser } from 'src/helpers/checkAuthentication';
import { getVerifyPermission } from '@repo/shared/helpers';
import { getSite } from 'src/api/admin/sites';

export const Route = createFileRoute('/_admin/$siteId')({
	loader: async ({ params }) => {
		const { siteId } = params;
		const site = await getSite(siteId);
		return { site };
	},
	component: SiteLayout,
});

function SiteLayout() {
	return <Outlet />;
}
